import AssociatedAsset from './associatedAsset'
export default AssociatedAsset
